module.exports = __webpack_public_path__ + "img/Telegram.8c59a31a.png";